var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmoke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1926,
    height: 40,
    viewBox: "0 0 1926 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4288_54350)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4288_54350",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1926,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1926,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4288_54350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1786.71 67.1372C1844.95 123.119 1892.5 190.132 1926 264.807V-130.532C1892.52 -55.8372 1844.95 11.1559 1786.71 67.1372Z",
    fill: "url(#paint0_linear_4288_54350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.333 67.137C838.251 -1.17985 783.119 -85.9241 750.016 -180.998H362.289C416.718 -87.5487 447.935 21.1044 447.935 137.059C447.935 422.22 259.308 663.295 0 742.483V903.146H841.421C761.994 797.381 714.927 665.943 714.927 523.492C714.927 344.195 789.519 182.329 909.333 67.1571V67.137Z",
    fill: "url(#paint1_linear_4288_54350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.333 67.137C1023.13 -42.2382 1177.71 -109.472 1348.02 -109.472C1518.33 -109.472 1672.91 -42.2181 1786.71 67.137C1844.95 11.1557 1892.5 -55.8574 1926 -130.533V-180.998H750.017C783.12 -85.9241 838.272 -1.15979 909.333 67.137Z",
    fill: "url(#paint2_linear_4288_54350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.935 137.059C447.935 21.1044 416.718 -87.5287 362.289 -180.998H0V742.463C259.308 663.295 447.935 422.2 447.935 137.038V137.059Z",
    fill: "url(#paint3_linear_4288_54350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.333 67.1365C1023.13 176.512 1177.71 243.745 1348.02 243.745C1518.33 243.745 1672.91 176.492 1786.71 67.1365C1672.91 -42.2387 1518.33 -109.472 1348.02 -109.472C1177.71 -109.472 1023.13 -42.2186 909.333 67.1365Z",
    fill: "url(#paint4_linear_4288_54350)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4288_54350",
    x1: 1926,
    y1: 663.879,
    x2: 1926,
    y2: -227.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989583,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#A4A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4288_54350",
    x1: 1368.42,
    y1: 782.002,
    x2: -437.457,
    y2: -144.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989583,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#A4A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4288_54350",
    x1: 749.778,
    y1: 67.2583,
    x2: 2475.57,
    y2: 67.2583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989583,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#A4A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4288_54350",
    x1: -621.649,
    y1: 231.429,
    x2: 647.672,
    y2: 231.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989583,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#A4A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4288_54350",
    x1: 1104.15,
    y1: 289.49,
    x2: 1428.48,
    y2: -411.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989583,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#A4A3A3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4288_54350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1926,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoke);
export default __webpack_public_path__ + "static/media/smoke.b3a5560b060434bc0e30f595faee43e2.svg";
export { ForwardRef as ReactComponent };